import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 0;
  overflow: hidden;
  z-index: 999999999999999;
`;
